export interface Course {
  id: string
  title: string
  subtitle: string
  description: string
  duration: string
  format: string
  price: string
  priceUSD: string
  image: string
  category: 'professional' | 'career' | 'corporate'
}

export const courses: Course[] = [
  {
    id: 'executive-assistant',
    title: 'Executive Assistant Mastery Course',
    subtitle: 'Be the EA trusted by Leading CEOs',
    description:
      'A practical, high-impact program designed to equip Executive Assistants with the skills, confidence, and mindset needed to excel in modern executive support roles.',
    duration: '8 weeks',
    format: 'Self-paced, cohort-based',
    price: '₦150,000',
    priceUSD: '$100',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/h3hyRfvSTPWr9FUqGeFrPH/Gemini_Generated_Image_ti5bjfti5bjfti5b.png',
    category: 'professional',
  },
  {
    id: 'virtual-sales',
    title: 'Virtual Sales Professionals Training',
    subtitle: 'Master modern sales skills and transform your career',
    description:
      'An 8-week online program that teaches practical sales know-how you can use right away. Learn to find prospects, build trusting relationships and close deals that last.',
    duration: '8 weeks',
    format: 'Self-paced with live masterclasses',
    price: '₦150,000',
    priceUSD: '$100',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/xu7fwWVByGy8DeYDjx7PRK/IMG-20250331-WA0007.jpg',
    category: 'professional',
  },
  {
    id: 'employability-skills',
    title: 'Employability Skills Course',
    subtitle: 'Land the Job. Thrive at Work.',
    description:
      'An 8-week, hands-on online program that bridges the gap between education and the workplace. Move from theory to practice with essential skills employers want.',
    duration: '8 weeks',
    format: 'Self-paced with live cohort interactions',
    price: '₦10,000',
    priceUSD: '$7',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/b4MYSaEckGRDbEPwpZELiK/employab.png',
    category: 'career',
  },
  {
    id: 'smartstart-onboarding',
    title: 'SmartStart Onboarding Bundle',
    subtitle: 'Onboard Smarter. Equip Early. Grow Faster.',
    description:
      'A ready-to-go, 3-in-1 training solution for startups, corporates, and HR teams. Onboard new talent quickly and effectively with job-ready skills.',
    duration: 'Flexible (2-3 weeks)',
    format: 'Self-paced, cohort-friendly',
    price: 'Custom',
    priceUSD: 'Contact us',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/goAyKf2esTbxcWp4kZ6DeP/IMG_20251023_125626.jpg',
    category: 'corporate',
  },
]
